import { render, staticRenderFns } from "./myComplaint.vue?vue&type=template&id=051fa192&scoped=true&"
import script from "./myComplaint.vue?vue&type=script&lang=js&"
export * from "./myComplaint.vue?vue&type=script&lang=js&"
import style0 from "./myComplaint.vue?vue&type=style&index=0&id=051fa192&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051fa192",
  null
  
)

export default component.exports